import { useState } from 'react'
import { CSVLink } from 'react-csv'
import CircularProgressBar from '../CircularProgressBar'
import { ExportButton } from './export-button'
import { Button } from './button'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './dialog'

export function ExportAllRows({
  allRows,
  headers,
  onExport,
}: {
  allRows: any[]
  headers?: { label: string }[]
  onExport?: () => Promise<void>
}) {
  const [isExportPanelOpen, setIsExportPanelOpen] = useState(false)
  const [isPreparing, setIsPreparing] = useState(false)

  const openExport = async () => {
    setIsPreparing(true)
    try {
      await onExport?.()
      setIsExportPanelOpen(true)
    } finally {
      setIsPreparing(false)
    }
  }

  return (
    <>
      <ExportButton onClick={openExport} disable={allRows.length === 0 || isPreparing} />
      <Dialog open={isExportPanelOpen} onOpenChange={setIsExportPanelOpen}>
        <DialogContent className="sm:max-w-115">
          <DialogHeader>
            <DialogTitle className="sr-only">Export</DialogTitle>
            <DialogDescription className="sr-only">Export data to CSV</DialogDescription>
          </DialogHeader>
          <div className="flex flex-col items-center justify-center">
            <div className="mt-9 w-full px-7">
              <div className="mx-auto mb-6 flex w-fit flex-col items-center">
                <CircularProgressBar progress={100} />
                <p className="mt-6 text-heading-md">File is ready to download</p>
                <Button variant="primary" asChild className="mx-auto mt-6">
                  <CSVLink
                    data={allRows}
                    onClick={() => setIsExportPanelOpen(false)}
                    filename="export.csv"
                    target="_blank"
                  >
                    Download
                  </CSVLink>
                </Button>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}
